import { Stack } from '../../design-system/stack/stack';
import { ViewProps } from './file-drop-zone';
import { FileDropZoneView } from './file-drop-zone-view';

type FileDropZoneStackedViewProps = Omit<ViewProps, 'variant'>;

export const FileDropZoneStackedView = (props: FileDropZoneStackedViewProps) => {
  return (
    <Stack space={3} align="center">
      <FileDropZoneView {...props} variant="STACKED" />
    </Stack>
  );
};
